/**
 * 天猫相关
 */

const tmall = {
  state: () => ({
    // 拓展字段schema
    // key为需要拓展的字段name
    extendsFields: {},
    isNewWirelessDesc: false, // 是否是新版移动端详情
  }),
  mutations: {
    updateExtendsFields(state, newExtendsFields) {
      state.extendsFields = {
        ...state.extendsFields,
        ...newExtendsFields
      }
    },
    setExtendsFields(state, newExtendsFields) {
      state.form = newExtendsFields
    },
    setTMIsNewWirelessDesc(state, bool) {
      state.isNewWirelessDesc = bool
    },
  },
  actions: {
    updateExtendsFields({commit}, extendsFields) {
      commit("updateExtendsFields", extendsFields)
    },
    clearExtendFields({commit}) {
      commit("setExtendsFields", {})
    },
    updateTMIsNewWirelessDesc({commit}, data) {
      commit('setTMIsNewWirelessDesc', data)
    },
  },
  getters: {
    tmExtendsFields(state) {
      return state.extendsFields
    },
    tmIsNewWirelessDesc(state) {
      return state.isNewWirelessDesc
    },
  }
}

export default tmall
